<template>
  <div>
    <Header></Header>
    <Banner></Banner>
    <ModelSlogan></ModelSlogan>
    <HomeLifeStyle :videoSrc="videoUrl"></HomeLifeStyle>
    <ModelIaaMobility></ModelIaaMobility>
    <Footer></Footer>
  </div>
</template>
<script>
import Banner from "../../components/banner";
import ModelIaaMobility from "../../components/modelIaaMobility";
import ModelSlogan from "../../components/afterCarShow/modelSlogan";
import HomeLifeStyle from "../../components/Lifestyle/homeLifestyle.vue";

export default {
  components: {
    Banner,
    ModelIaaMobility,
    ModelSlogan,
    HomeLifeStyle,
  },
  data() {
    return {
      videoUrl:
        "https://res.gwm.com.cn/2021/04/30/1804281_151_6d45da9877da91b676a9b6b323a67b10_mocca_10s.mp4",
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
</style>